import React, { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
  CardElement,
  Elements,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { toast } from "react-toastify";
import { PaymentApi } from "../../Redux/Auth/Auth_Action";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// const stripePromise = loadStripe("");
const stripePromise = loadStripe(process.env.REACT_APP_SEC_KEY);
//process.env.REACT_APP_SEC_KEY

// test key

// live key
// pk_live_51LYaF3FOmHfKa5AZAPDK1OA5HMjLKpqRZm2XIHjDNC1a0DIfNUC290AhGQbjqXSvyXsHJJtNoWrE1fnNtLEeCb5O00FFEmBL5O
const CheckoutForm = (props) => {
  const [loaderz, setLoaderz] = useState(false);
  // console.log('checkout', props?.handleClickOpen?.interests);
  //   const { StepTwoContinue, handleNext, setCardToken, cardToken } = props;
  const [formData, setFormData] = useState({});
  const [payProcessing, setPayProcessing] = useState(false);
  //   const [error, setError] = useState(false);
  const [done, setDone] = useState(false);
  const dispatch = useDispatch();
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const [paybutton, setPayButton] = useState(true);

  const reduxStateToken = useSelector((state) => state.Auth.token);
  // console.log(props.handleClickOpen, 'stripe checkout formz');
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoaderz(true)
    if (elements == null) {
      return;
    }
    const cardElement = elements.getElement(CardElement);
    const payload = await stripe.createToken(cardElement);
    // setCardToken(payload?.token?.id);
    // console.log("check", props?.handleClickOpen?.interests);

    if (payload?.error?.message) {
      toast.error(payload?.error?.message);
      setLoaderz(false);
    } else {
      if (payload?.token?.id || props?.handleClickOpen?.interests) {
        let data = { _token: payload?.token?.id, interest: props?.handleClickOpen?.interests }
        dispatch(PaymentApi(data, reduxStateToken))
          .then((res) => {
            // console.log(res);
            let NewData = { price: props?.handleClickOpen?.price, slug: props.handleClickOpen?.slug, paymentType: "stripe", interest: props.handleClickOpen?.interests }
            // console.log(NewData, 'new data from stripe form response');
            navigate('/checkout', { state: { NewData } });
            setLoaderz(false)
          })
          .catch((e) => {
            console.log("error", e?.response?.data);
            // toast.error()
            // console.log('data from stripe', data);
            setTimeout(() => {
              setLoaderz(false);
            }, 2000);
          })
        return;
      } else {
        toast.error("Select Interests");
        setTimeout(() => {
          // console.log("bef working", loaderz);
          setLoaderz(false);
          // console.log("working", loaderz);
        }, 2000);
        //   toast.error("Something Went Wrong");
        return;
      }
    }
    setPayProcessing(true);
    setDone(true);
    setPayProcessing(false);
  };

  return (
    <>
      <form style={{ padding: "0rem 0 0 0", borderRadius: "4px" }} onSubmit={handleSubmit}>
        <CardElement
          onChange={(e) => {
            if (e.complete) {
              setPayButton(false);
            } else {
              setPayButton(true);
            }
          }}
        />
        <br />

        <ul className="list-inline">
          <li>
            <button
              type="submit"
              style={{ background: "#162C71", color: "#fff", width: "100%", padding: "1rem", borderRadius: 0 }}
              className="default-btn stripePay-Btn btn f-16 f-mon-reg"
              disabled={!stripe || !elements || paybutton
                || loaderz}
            >
              Pay Now
            </button>
          </li>
        </ul>
      </form>
    </>
  );
};

const StripeForm = (props) => {

  let newState = { slug: props.handleSet.slug, price: props.handleSet.price, interests: props.handleSet.interestsData }
  console.log('from stripe page', newState);

  return (
    <Elements stripe={stripePromise}>
      <CheckoutForm handleClickOpen={newState}
      />

    </Elements>
  );
};

export default StripeForm;